import reducer from './reducers'
import { imageSelectors } from './selectors'

export type ImagesState = ReturnType<typeof reducer>
export default reducer
export { imageSelectors }
